import Image from "next/image";
import React from "react";

export default function ImageCaption({
  data,
}: {
  data: {
    full_width: boolean;
    caption: string;
    image: { alt?: string; copyright?: string; dimension: { width: number; height: number }; url: string };
  };
}) {
  return (
    <div className="flex flex-col space-y-4">
      <div className="relative aspect-h-9 aspect-w-16">
        <Image src={data.image.url} alt={data.image.alt} layout="fill" objectFit="contain" />
      </div>
      {data.caption && (
        <div>
          <p className="text-sm italic text-center text-gray-500">{data.caption}</p>
        </div>
      )}
    </div>
  );
}
